<div class="bg-black bg-opacity-75">
  <div class="container text-white py-2">
    <div class="row gy-2 gy-lg-0 align-items-lg-center">
      <div class="col py-3">
        <p class="x-small inter-regular mb-0">
          Usamos cookies para hacer que tu visita sea mejor y para ofrecerte cosas que te interesen según lo que busques
          en la web. Si sigues navegando, entenderemos que estás de acuerdo con nuestras
          <a
            class="inter-semi-bold text-white text-decoration-underline"
            href="./assets/pdf/POLÍTICA%20DE%20COOKIES.pdf"
            target="_blank"
          >
            Políticas de cookies.
          </a>
          <br />
          Si prefieres, puedes desactivarlas en tu navegador y seguir usando nuestra página.
        </p>
      </div>

      <div class="col-12 col-lg-auto">
        <app-action-buttons
          (firstButtonClick)="onOpenConfigurationClick()"
          (secondButtonClick)="onAcceptAllClick()"
          [gap]="{ base: 3, xxl: 4 }"
          [isMobile]="isMobile()"
          firstButtonCss="text-white"
          firstButtonLabel="Configurar mis cookies"
          firstButtonStyleType="link"
          orientation="horizontal"
          secondButtonCss="btn-light text-primary"
          secondButtonLabel="Aceptar cookies"
        ></app-action-buttons>
      </div>
    </div>
  </div>
</div>
